import { gql } from '@apollo/client';

const UPDATE_ALTERNATE_EMAIL_CONSENT = gql`
  mutation UpdateAlternateEmailConsent($input: UpdateUserPreferencesInput!) {
    updateUserPreferencesV2(input: $input) {
      preferences {
        isReceivingNewsTrendsOffers
      }
    }
  }
`;

export default UPDATE_ALTERNATE_EMAIL_CONSENT;
